import React from "react";
import { t, businessName, itemName, customerMobile } from "./invoiceTemplate.shared";
import { InvoiceBrandMark, InvoiceSignature } from "./InvoiceBrandAssets";
import "./RetailInvoiceTemplate.css";

const RetailInvoiceTemplate = ({
  invoice,
  invoiceNumber,
  businessSnapshot,
  customerName,
  customerSnapshot,
  billingAddress,
  shippingAddress,
  calculatedItems = [],
  totals = {},
  grandTotal = 0,
  paidAmount = 0,
  balanceAmount = 0,
  displayCurrency,
  formatAddress,
  formatDate,
  formatLabel,
  formatNumber,
  numberToWords,
}) => (
  <section className="invoice-retail">
    <header><div className="invoice-template-brand-block"><InvoiceBrandMark businessSnapshot={businessSnapshot} /><div><h1>{businessName(businessSnapshot)}</h1><p>{formatAddress(businessSnapshot?.address || businessSnapshot)}</p></div></div><aside><span>RETAIL INVOICE</span><b>{invoiceNumber}</b><small>{formatDate(invoice?.documentDate)}</small></aside></header>
    <div className="invoice-retail__customer"><span>Customer <b>{customerName}</b></span><span>Mobile <b>{customerMobile(customerSnapshot, invoice)}</b></span><span>GSTIN <b>{t(customerSnapshot?.gstin)}</b></span></div>
    <table><thead><tr><th>#</th><th>Product / Service</th><th>Qty</th><th>Rate</th><th>Disc.</th><th>Tax</th><th>Total</th></tr></thead><tbody>{calculatedItems.map((item,index)=><tr key={item?._id || index}><td>{index+1}</td><td><b>{itemName(item)}</b><small>{item?.sku ? `SKU: ${item.sku}` : ""}</small></td><td>{formatNumber(item?.calculation?.quantity,0,2)}</td><td>{displayCurrency(item?.calculation?.rate)}</td><td>{displayCurrency(item?.calculation?.discountAmount)}</td><td>{formatNumber(item?.taxPercentage,0,2)}%</td><td><b>{displayCurrency(item?.calculation?.totalAmount)}</b></td></tr>)}</tbody></table>
    <div className="invoice-retail__checkout"><div><small>AMOUNT IN WORDS</small><b>Indian Rupees {numberToWords(grandTotal)} Only</b><p>{invoice?.customerNotes || "Thank you for shopping with us."}</p></div><aside><span>Gross <b>{displayCurrency(totals?.grossAmount ?? totals?.subtotal ?? 0)}</b></span><span className="grand">TOTAL <b>{displayCurrency(grandTotal)}</b></span><span>Received <b>{displayCurrency(paidAmount)}</b></span><span className="due">Balance <b>{displayCurrency(balanceAmount)}</b></span></aside></div>
    <InvoiceSignature businessSnapshot={businessSnapshot} />
  </section>
);

export default RetailInvoiceTemplate;
